import React from 'react';
import { ComposableModal, ModalContent, ModalFooter } from '#app/components/ModalForm';

export interface BaseInstructionProps {
  show: boolean;
  onClose?: () => void;
  modalName: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  footerStyle?: React.CSSProperties;
}

const BaseInstruction: React.FC<BaseInstructionProps> = ({
  show,
  onClose,
  modalName,
  children,
  footer,
  footerStyle,
}) => {
  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <ComposableModal show={show} size="large" trigger="" title={modalName} onClose={handleClose}>
      <ModalContent>{children}</ModalContent>
      {footer != null ? <ModalFooter style={footerStyle}>{footer}</ModalFooter> : <ModalFooter />}
    </ComposableModal>
  );
};

export default BaseInstruction;
